import { EntityState, ListUpdateState } from "@/store/type";
import { FormValue } from "@/components/form-area/type";
import { VehicleApply } from "@/api";

export default {
  state: {
    apply: null,
    key: null,
    vehicleApply: null,
    updateState: null,
  },
  getters: {
    apply: (state: EntityState) => state.apply,
    key: (state: EntityState) => state.key,
    vehicleApply: (state: EntityState) => state.vehicleApply,
    updateState: (state: EntityState) => state.updateState,
  },
  mutations: {
    setApply(state: EntityState, value: FormValue | null) {
      state.apply = value;
    },
    setKey(state: EntityState, value: string | null) {
      state.key = value;
    },
    setVehicleApply(state: EntityState, value: VehicleApply | null) {
      state.vehicleApply = value;
    },
    setUpdateState(state: EntityState, value: ListUpdateState | null) {
      state.updateState = value;
    },
  },
  actions: {},
};
